var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{attrs:{"size":"mini"},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},_vm._l((_vm.defaultValueArr),function(item,i){return _c('el-checkbox',{key:i,attrs:{"label":item,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.$t(`sitParam.${_vm.label}Values.${item}`)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }